import r from "../managers/braze-instance.js";
import InAppMessage from "./models/in-app-message.js";
import se from "./in-app-message-manager-factory.js";
import { logInAppMessageImpression } from "./log-in-app-message-impression.js";
import { MUST_BE_IN_APP_MESSAGE_WARNING as sr } from "../common/constants.js";
import { logger as E, EventTypes as m } from "../../shared-lib/index.js";
import ot from "../triggers/models/trigger-events.js";
import { TriggersProviderFactory as rt } from "../triggers/triggers-provider-factory.js";
export function logInAppMessageClick(o) {
  if (!r.rr()) return !1;
  if (!(o instanceof InAppMessage)) return E.error(sr), !1;
  var s = se.ea().rt(o, m.$i);
  if (s) {
    o.Ur() || logInAppMessageImpression(o);
    for (var _r = 0; _r < s.ue.length; _r++) rt.o().ve(ot.Qr, [o.triggerId], s.ue[_r]);
  }
  return s.W;
}